import axios from 'axios';

// eslint-disable-next-line no-undef
const baseUrl = process.env.REACT_APP_API_URL;

// eslint-disable-next-line no-undef
const baseUmsUrl = process.env.REACT_APP_UMS_API_URL;

export async function sendElderDetailsForExtraction(data) {
	try {
		const response = await axios.post(`${baseUrl}/add_elder`, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function addElderDetails(data, token) {
	try {
		const response = await axios.post(`${baseUmsUrl}/elder`, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function getResidentIds(elderHomeId, token, type = null) {
	try {
		const params = {};
		if (type) {
			params.type = type;
		}

		const response = await axios.get(
			`${baseUmsUrl}/elder/home/${elderHomeId}/ids`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
				params,
			},
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchElder(id, token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/elder/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchElderFiles(id, token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/elder/${id}/files`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchDashboardData(id, token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/home/${id}/dashboard`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchAllCarePlanData(id, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/home/${id}/dashboard/plan`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchOptimizedPlans(token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/plan/optimized`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchResidents(home, token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/elder/home/${home}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function addInitialCarePlan(data, token) {
	try {
		const response = await axios.post(`${baseUmsUrl}/plan/initial`, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function addOptimizedCarePlan(data, token) {
	try {
		const response = await axios.post(
			`${baseUmsUrl}/plan/optimized`,
			data,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function updateCarePlan(id, data, token, planType) {
	try {
		const response = await axios.put(
			`${baseUmsUrl}/plan/${planType}/${id}`,
			data,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchCarePlanById(id, token, planType) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/plan/${planType}/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchElderDataFile(route, token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/${route}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchCarePlanUpdateOverTIme(id, token, type) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/home/${id}/dashboard/date/${type}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function updateElderDetails(id, data, token) {
	try {
		const response = await axios.put(`${baseUmsUrl}/elder/${id}`, data, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function deleteResident(id, token) {
	try {
		const response = await axios.delete(`${baseUmsUrl}/elder/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return error.response.data;
		} else {
			console.error('Something went wrong', error.message);
			return { message: error.message };
		}
	}
}

export async function filterCarePlanStat(id, token, start, end) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/home/${id}/dashboard/counts/start/${start}/end/${end}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function generateSummary(data, route) {
	try {
		const response = await axios.post(`${baseUrl}/${route}`, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return {
				error: true,
				message: error.response.data.error,
				data: error.response.data,
			};
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function storeSummary(data, id, token) {
	try {
		const response = await axios.post(
			`${baseUmsUrl}/home/${id}/summarizer`,
			data,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchAllSummarizers(id, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/home/${id}/summarizer`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchSummary(id, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/home/summarizer/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function storeExternalApiConfig(token, data) {
	try {
		const response = await axios.post(`${baseUmsUrl}/config`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetch360DashboardData(id, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/home/${id}/360Dashboard`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchExternalElderPlan(id, token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/external/plan/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchLatestInitialPlan(id, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/plan/initial/latest/elder/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchExternalLatestElderPlanData(home, id, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/external/latest/home/${home}/plan/elder/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchLatestElderPlanData(id, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/elder/latest/plan/elder/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function updateExternalPlanOptimizedFlag(id, token) {
	try {
		const response = await axios.put(
			`${baseUmsUrl}/external/plan/${id}`,
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchExternalElder(id, token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/external/elder/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchAllExternalElder(home, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/external/elder/home/${home}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchElderCareNotes(route, token) {
	try {
		const response = await axios.get(`${baseUmsUrl}/${route}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function storeUpdatedElder(token, body, route) {
	try {
		const response = await axios.put(`${baseUmsUrl}/${route}`, body, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function generateNotificationData(data, docType, fileName) {
	const response = await fetch(
		`${baseUrl}/cqc_notifications/finalize?response_format=binary`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		},
	);

	if (!response.ok) {
		throw new Error('Generation failed');
	}

	const blob = await response.blob();

	const contentDisposition = response.headers.get('Content-Disposition');

	let filename = `${fileName}.${docType}`;

	if (contentDisposition) {
		const match = contentDisposition.match(
			/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
		);

		if (match?.[1]) {
			filename = match[1].replace(/['"]/g, '');
		}
	}

	return { blob, filename };
}

export async function fetchCQCReportData(data) {
	try {
		const response = await axios.post(
			`${baseUrl}/cqc_notifications/generate`,
			data,
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchExternalEldersReview(id, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/external/elder?home=${id}&reviewed=false`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchExternalElderReview(id, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/external/review/elder/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchApiConfigs(id, token) {
	try {
		const response = await axios.get(
			`${baseUmsUrl}/external/review/elder/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return response.data.content;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}
